import { useState } from "react"
import { useUser } from "@/apis/bff"
import { Banner } from "@/components/ui/banner"
import { getPersistedLanguage } from "@/lib/language-storage"
import { selectContentForLanguage } from "@/lib/select-content-for-language"
import { getDisplayForByRole, getVariantNews } from "@/modules/admin/news/helpers/news-helper"
import { useShowingNewsSubscription$data } from "@/modules/admin/news/services/__generated__/useShowingNewsSubscription.graphql"
import { useShowingNewsSubscription } from "@/modules/admin/news/services/useShowingNewsSubscription"
import { useBannerStore } from "@/stores/useBannerStore"

const NewsBannerNotify = () => {
  const [newsBannerList, setNewsBannerList] = useState<useShowingNewsSubscription$data | null | undefined>(null)
  const language = getPersistedLanguage()
  const { role } = useUser()

  const dismissedBanners = useBannerStore((state) => state.banners)
  const dismissBanner = useBannerStore((state) => state.dismissBanner)

  useShowingNewsSubscription(setNewsBannerList)

  if (!newsBannerList) {
    return null
  }

  return (
    <>
      {newsBannerList.showingNews.map((newsBanner) => {
        const shouldDisplay = newsBanner.displayFor.includes(getDisplayForByRole(role)) || role === "MedicalSupervisor"
        if (!shouldDisplay || !!dismissedBanners[newsBanner.id]) {
          return null
        }
        return (
          <Banner
            variant={getVariantNews(newsBanner.criticalityLevel)}
            key={newsBanner.id}
            className="py-1"
            iconClassName="pt-2"
            dismissOptions={{
              onDismiss: () => dismissBanner(newsBanner.id),
            }}>
            {selectContentForLanguage(language, {
              en: newsBanner.englishContent,
              de: newsBanner.germanContent,
              fr: newsBanner.frenchContent,
              it: newsBanner.italianContent,
            })}
          </Banner>
        )
      })}
    </>
  )
}

export { NewsBannerNotify }
